module.exports = __webpack_public_path__ + "media/application/images/ui/member-icon-dark-6e131685b13c91ed836ac3a80cf05633.png";